var _defs, _style, _g, _path, _g2, _g3, _path2, _path3, _path4, _g4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g5, _g6, _g7, _g8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3710 3710",
    width: 800,
    height: 800,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "10780168_19197585-ai") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x1: 2670.3,
    y1: 6028.6,
    x2: -719.6,
    y2: 1818.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b37cff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f895e7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g2",
    x1: 655.2,
    y1: 454.8,
    x2: 1737.1,
    y2: 1158.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a737d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef497a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g3",
    x1: 190.5,
    y1: 1255.9,
    x2: 1134.7,
    y2: 455.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ce1567"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7a1dbc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g4",
    x1: -1447,
    y1: 3170.3,
    x2: 2216.7,
    y2: -1173.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#53d8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840f7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g5",
    x1: 3522.9,
    y1: 1056.9,
    x2: 2595.1,
    y2: 6225.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#53d8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840f7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g6",
    x1: 1791.1,
    y1: -131.1,
    x2: 2144.2,
    y2: 2902.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#53d8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840f7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g7",
    x1: 352.8,
    y1: 2676.3,
    x2: 1687.6,
    y2: -1068.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#53d8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840f7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g8",
    x1: 1472,
    y1: 1294.1,
    x2: 1008.2,
    y2: 2791.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ce1567"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7a1dbc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g9",
    x1: 2950.7,
    y1: 1306,
    x2: 2486.8,
    y2: 2803.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ce1567"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7a1dbc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g10",
    x1: 1564,
    y1: 895,
    x2: 1100.2,
    y2: 2392.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ce1567"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7a1dbc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g11",
    x1: 2787.7,
    y1: 2230.8,
    x2: 2323.8,
    y2: 3728.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ce1567"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7a1dbc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g12",
    x1: 3052.5,
    y1: 1791.1,
    x2: 2588.7,
    y2: 3288.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ce1567"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7a1dbc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g13",
    x1: 1854.6,
    y1: 1671.4,
    x2: 2416.5,
    y2: 1937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c4421b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5c0e16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g14",
    x1: 1600.1,
    y1: 1638.3,
    x2: 2444.7,
    y2: 2037.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c4421b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5c0e16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g15",
    x1: 1612.5,
    y1: 1934.2,
    x2: 1727.7,
    y2: 1674.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a737d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef497a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g16",
    x1: 1420.8,
    y1: 2303.5,
    x2: 2340.4,
    y2: 1599.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2b3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150e42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g17",
    x1: 2288.2,
    y1: 1966.3,
    x2: 2650,
    y2: 2348.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c4421b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5c0e16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g18",
    x1: 2177.6,
    y1: 1442.2,
    x2: 1249.5,
    y2: 2468.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdf53f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d93c65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g19",
    x1: 2328.7,
    y1: 1956.2,
    x2: 1750.4,
    y2: 2993.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdf53f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d93c65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g20",
    x1: 2139.1,
    y1: 4233.7,
    x2: 3238.5,
    y2: 2730.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c4421b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5c0e16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g21",
    x1: 508.5,
    y1: 2716.1,
    x2: 895.9,
    y2: 1672.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7c27dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2b41d9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g22",
    x1: 961.5,
    y1: 3101.9,
    x2: 1050.3,
    y2: 2789.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2b3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150e42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g23",
    x1: 3299.9,
    y1: 3477.4,
    x2: 3141.1,
    y2: 1621.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c4421b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5c0e16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g24",
    x1: -616.1,
    y1: 2285.8,
    x2: -236.7,
    y2: 1263.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7c27dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2b41d9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g25",
    x1: 2128.2,
    y1: 2718.9,
    x2: 1692.4,
    y2: 3476.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2b3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150e42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g26",
    x1: 1170.9,
    y1: 1936.2,
    x2: 1791.1,
    y2: 1346.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a737d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef497a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g27",
    x1: 2076.5,
    y1: 1198.2,
    x2: 2038.7,
    y2: 1704.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c4421b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5c0e16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g28",
    x1: 1921.6,
    y1: 1171.7,
    x2: 1549.1,
    y2: 1505.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c4421b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5c0e16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g29",
    x1: 1550.6,
    y1: 1471,
    x2: 1732.1,
    y2: 1069.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2b3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150e42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g30",
    x1: 2020.4,
    y1: 1361.6,
    x2: 1836,
    y2: 1936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2b3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150e42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g31",
    x1: 1112,
    y1: 1841.8,
    x2: 1470.3,
    y2: 1299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a737d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef497a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g32",
    x1: 1428.4,
    y1: 2142.4,
    x2: 1552.1,
    y2: 2380.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c4421b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5c0e16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g33",
    x1: 2524.7,
    y1: 1831.7,
    x2: 2392.2,
    y2: 2297.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdf53f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d93c65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g34",
    x1: 1374.6,
    y1: 1866.1,
    x2: 1181.6,
    y2: 2429.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9b776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g35",
    x1: 1735.1,
    y1: 1562.6,
    x2: 1841.3,
    y2: 2316.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdf53f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d93c65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g36",
    x1: 1655,
    y1: 2018,
    x2: 982.8,
    y2: 3096.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2b3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150e42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g37",
    x1: 689.3,
    y1: 1817.9,
    x2: 1401.3,
    y2: 2470.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9b776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g38",
    x1: 1794.5,
    y1: 1819.6,
    x2: 1359.3,
    y2: 2656.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cb236d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c246d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g39",
    x1: 635.1,
    y1: 1531.2,
    x2: 1191.4,
    y2: 1328.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cb236d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c246d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g40",
    x1: -138.7,
    y1: 2482.6,
    x2: 321.3,
    y2: 1718.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7c27dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2b41d9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g41",
    x1: 1067.6,
    y1: 2348.1,
    x2: 826.5,
    y2: 3403.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2b3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150e42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g42",
    x1: 1042,
    y1: 2880.2,
    x2: 1746.2,
    y2: 3584.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2b3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150e42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g43",
    x1: 1579.9,
    y1: 1618.2,
    x2: 991.3,
    y2: 3395.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdf53f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d93c65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g44",
    x1: 1275.4,
    y1: 1101.3,
    x2: 1555,
    y2: 1523.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdf53f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d93c65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g45",
    x1: 1806.8,
    y1: 1138.3,
    x2: 773.9,
    y2: 2582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9b776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g46",
    x1: 1215.3,
    y1: 1293.8,
    x2: 1174.4,
    y2: 2953.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9b776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g47",
    x1: 1272.3,
    y1: 1247.8,
    x2: 1340.6,
    y2: 1649.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9b776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g48",
    x1: 936.5,
    y1: 1343.7,
    x2: 1072.6,
    y2: 1199.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2b3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150e42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g49",
    x1: 995.7,
    y1: 1728.7,
    x2: 982.3,
    y2: 1416.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9b776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g50",
    x1: 380.8,
    y1: 1271.9,
    x2: 1003.5,
    y2: 819.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cb236d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c246d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g51",
    x1: 1192.9,
    y1: 1255.7,
    x2: 1019,
    y2: 1248.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdf53f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d93c65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g52",
    x1: 1203.7,
    y1: 1186,
    x2: 1101.4,
    y2: 1498.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdf53f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d93c65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g53",
    x1: 1326.9,
    y1: 1270.6,
    x2: 1066.3,
    y2: 1386.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdf53f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d93c65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g54",
    x1: 2390.7,
    y1: 435.2,
    x2: 2492.3,
    y2: 1389.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdf53f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d93c65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g55",
    x1: 1791.5,
    y1: 992.4,
    x2: 3373.6,
    y2: 201.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdf53f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d93c65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g56",
    x1: 1740,
    y1: 1181.5,
    x2: 1493.8,
    y2: 63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdf53f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d93c65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g57",
    x1: 2039.3,
    y1: 633.4,
    x2: 1624.8,
    y2: 1699.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdf53f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d93c65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g58",
    x1: 2662,
    y1: 997.3,
    x2: 2263.1,
    y2: 1416.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdf53f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d93c65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g59",
    x1: 1958.5,
    y1: 1215.5,
    x2: 2613.1,
    y2: -133.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdf53f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d93c65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g60",
    x1: 1902.9,
    y1: 1371.5,
    x2: 2637.1,
    y2: 825.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdf53f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d93c65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g61",
    x1: 1882.9,
    y1: 611.2,
    x2: 2337.6,
    y2: 1073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdf53f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d93c65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g62",
    x1: 3244.4,
    y1: 470.9,
    x2: 2773.3,
    y2: 683.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c759e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#051042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g63",
    x1: 3235.9,
    y1: 496.9,
    x2: 2764.7,
    y2: 709.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c759e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#051042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g64",
    x1: 3227.2,
    y1: 513.2,
    x2: 2756,
    y2: 726.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c759e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#051042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g65",
    x1: 3213.7,
    y1: 534.5,
    x2: 2742.6,
    y2: 747.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c759e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#051042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g66",
    x1: 3210,
    y1: 555.5,
    x2: 2738.8,
    y2: 768.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c759e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#051042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g67",
    x1: 3201.4,
    y1: 576.6,
    x2: 2730.2,
    y2: 789.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c759e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#051042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g68",
    x1: 3192.6,
    y1: 592.9,
    x2: 2721.5,
    y2: 805.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c759e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#051042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g69",
    x1: 3179.3,
    y1: 619,
    x2: 2708.2,
    y2: 831.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c759e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#051042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g70",
    x1: 3170.7,
    y1: 640.1,
    x2: 2699.6,
    y2: 853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c759e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#051042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g71",
    x1: 3162,
    y1: 656.5,
    x2: 2690.8,
    y2: 869.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c759e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#051042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g72",
    x1: 3148.7,
    y1: 682.5,
    x2: 2677.5,
    y2: 895.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c759e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#051042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g73",
    x1: 3102,
    y1: 744.9,
    x2: 2698.3,
    y2: 927.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c759e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#051042"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { opacity: .3;fill: url(#g1) } \n\t\t.s1 { fill: url(#g2) } \n\t\t.s2 { mix-blend-mode: soft-light;fill: #ffffff } \n\t\t.s3 { fill: url(#g3) } \n\t\t.s4 { fill: url(#g4) } \n\t\t.s5 { fill: url(#g5) } \n\t\t.s6 { fill: url(#g6) } \n\t\t.s7 { fill: url(#g7) } \n\t\t.s8 { opacity: .2;fill: #ffffff } \n\t\t.s9 { fill: #ffffff } \n\t\t.s10 { fill: url(#g8) } \n\t\t.s11 { fill: url(#g9) } \n\t\t.s12 { fill: url(#g10) } \n\t\t.s13 { fill: url(#g11) } \n\t\t.s14 { fill: url(#g12) } \n\t\t.s15 { fill: url(#g13) } \n\t\t.s16 { fill: url(#g14) } \n\t\t.s17 { fill: url(#g15) } \n\t\t.s18 { fill: url(#g16) } \n\t\t.s19 { opacity: .3;fill: #ffffff } \n\t\t.s20 { fill: url(#g17) } \n\t\t.s21 { fill: url(#g18) } \n\t\t.s22 { fill: url(#g19) } \n\t\t.s23 { fill: url(#g20) } \n\t\t.s24 { fill: url(#g21) } \n\t\t.s25 { fill: url(#g22) } \n\t\t.s26 { fill: url(#g23) } \n\t\t.s27 { fill: url(#g24) } \n\t\t.s28 { fill: url(#g25) } \n\t\t.s29 { fill: url(#g26) } \n\t\t.s30 { fill: url(#g27) } \n\t\t.s31 { fill: url(#g28) } \n\t\t.s32 { fill: url(#g29) } \n\t\t.s33 { fill: url(#g30) } \n\t\t.s34 { fill: url(#g31) } \n\t\t.s35 { fill: url(#g32) } \n\t\t.s36 { fill: url(#g33) } \n\t\t.s37 { fill: url(#g34) } \n\t\t.s38 { fill: url(#g35) } \n\t\t.s39 { fill: url(#g36) } \n\t\t.s40 { fill: url(#g37) } \n\t\t.s41 { fill: url(#g38) } \n\t\t.s42 { fill: url(#g39) } \n\t\t.s43 { fill: url(#g40) } \n\t\t.s44 { fill: url(#g41) } \n\t\t.s45 { fill: url(#g42) } \n\t\t.s46 { fill: url(#g43) } \n\t\t.s47 { fill: url(#g44) } \n\t\t.s48 { fill: url(#g45) } \n\t\t.s49 { fill: url(#g46) } \n\t\t.s50 { fill: url(#g47) } \n\t\t.s51 { fill: url(#g48) } \n\t\t.s52 { fill: url(#g49) } \n\t\t.s53 { fill: url(#g50) } \n\t\t.s54 { fill: url(#g51) } \n\t\t.s55 { fill: url(#g52) } \n\t\t.s56 { fill: url(#g53) } \n\t\t.s57 { fill: url(#g54) } \n\t\t.s58 { fill: url(#g55) } \n\t\t.s59 { fill: url(#g56) } \n\t\t.s60 { fill: url(#g57) } \n\t\t.s61 { fill: url(#g58) } \n\t\t.s62 { fill: url(#g59) } \n\t\t.s63 { fill: url(#g60) } \n\t\t.s64 { fill: url(#g61) } \n\t\t.s65 { fill: url(#g62) } \n\t\t.s66 { fill: url(#g63) } \n\t\t.s67 { fill: url(#g64) } \n\t\t.s68 { fill: url(#g65) } \n\t\t.s69 { fill: url(#g66) } \n\t\t.s70 { fill: url(#g67) } \n\t\t.s71 { fill: url(#g68) } \n\t\t.s72 { fill: url(#g69) } \n\t\t.s73 { fill: url(#g70) } \n\t\t.s74 { fill: url(#g71) } \n\t\t.s75 { fill: url(#g72) } \n\t\t.s76 { fill: url(#g73) } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_Artboards_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m2852.2 2840.8c-56.3 59.2-109.6 97.5-151.7 127.7-494.7 354.9-1080.1 251.4-1204.5 226.2-183.7-37.3-538.8-109.5-795.5-411.4-388.4-456.7-327.9-1176.4-26.7-1651.4 55.1-86.9 346.2-569.2 937.9-646.5 358.1-46.8 775.5 47.6 1077.7 300.8 634.5 531.6 589.4 1605.5 162.8 2054.6z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m644.5 475.8c-0.7-14 19.8-19.3 29.6-7.8 99.2 116.7 327.3 453.2 164.6 936.6-204.1 606.5-96.3 861.8 64.9 1035.3 0 0-244.7-113.1-363.3-373.9-291.1-640.3 115.6-1342 104.2-1590.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m697.2 687c1.7 72 1.7 144-1.2 215.8-2.5 71.7-7.6 143.3-15.2 214.5-7.9 71.2-17.3 142.1-30.2 212.4-12.6 70.4-28.6 140.1-45 210-15.9 69.9-32.4 140.3-40.5 212.7-8.3 72.3-6.7 147.1 10.5 220.1 4.3 18.2 9 36.4 14.9 54.3 5.5 17.9 11.9 35.7 18.7 53.4 13.7 35.3 30.1 70 49.3 103.7 38.6 67.2 88.6 129.7 146.2 185.5 6.1 5.9 16.2 6.6 22.6 1.6 6.3-4.9 6.7-13.5 1-19.3l-0.1-0.1c-13.5-13.9-26.9-27.9-39.6-42.3-6.4-7.1-12.5-14.5-18.8-21.8-5.9-7.4-12.2-14.7-17.9-22.3-23.2-30-44.1-61.3-62.3-93.7-36.8-64.5-62.9-133.7-79.5-203.4-7.9-35-12.8-70.2-14.6-105.5-1.7-35.3-0.4-70.7 3.3-105.9 7.3-70.4 23-140.2 38.3-210.3 15.2-70.1 30-140.7 41.3-211.8q8.7-53.4 15.2-107c2.2-17.9 4.1-35.8 6-53.7q2.6-26.9 4.7-53.9c5.6-71.8 8.6-143.9 9-216.2 0-72.2-2.2-144.5-7.6-216.8-0.1-2-2.2-3.7-4.5-3.6-2.3 0-4.1 1.6-4 3.6z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m669.3 1777.7c-17.2 12.6-41.6 3.5-46.7-17.2-28-114-78-443.5 166.5-766.7 206.4-272.9 292.4-440.5 326.2-519.3 7.1-16.7 31.4-14.6 35.5 3.1 45.8 194.7 141.2 845.6-481.5 1300.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m645.3 1761.8q-0.8 0-1.6-0.2c-4.5-0.9-7.4-5.3-6.5-9.8 1-5.1 106.3-514.2 376.2-906.6 2.6-3.8 7.8-4.8 11.6-2.2 3.8 2.6 4.7 7.8 2.1 11.6-267.9 389.6-372.6 895.4-373.6 900.5-0.8 4-4.3 6.7-8.2 6.7z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m3183.5 1899.3c-29.8 679.7-648.7 1204.6-1382.4 1172.4-733.6-32.2-1304.2-609.3-1274.3-1289 29.8-679.7 648.7-1204.5 1382.4-1172.3 733.6 32.2 1304.2 609.3 1274.3 1288.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m852.1 1024.9c-29.2 46.9-51.7 99.6-47.5 154.6 4.9 63.8 37.2 123.5 38.8 187.3 2.8 108.4-80.8 199.1-106.9 304.3-29.2 117.6 80.8 251.6 124.6 317.3 43.8 65.6 25-53.3 51.6-99.7 26.5-46.3 83.8 195.1 173.3 248.1 48 28.4 104.3 47.4 138.9 91.2 50.3 63.9 36.4 154.9 28.8 235.9-7.5 81.1 3.8 179.8 76.8 215.8 42.9 21.2 97.5 14.1 136.3 42.2 68.1 49.5 35.6 157.2 62.6 237 29.3 86.6 87.5 87.8 177.5 106.2 90.1 18.3-11.3-179.4 30.9-248.6 22.1-36.3 56-65.2 73.5-104 24.2-53.8 17.4-125.7 64.4-161.4 35.3-26.7 84.3-19.5 128.6-19.9 44.2-0.4 98-19.6 103-63.5 4.5-39-34.6-70.1-72.8-79.2-38.2-9-78.9-4.7-116.4-16.2-107.3-33.1-157.4-183.3-269.4-190.3-95.8-6-176.1 101.5-270.2 82.8-52.5-10.5-88.4-57-127.3-93.7-50.1-47.1-112.2-82.5-151.9-138.6-39.7-56.1-46.5-145.7 10.1-184.8 41.9-29.1 101.6-17.3 143.1 12.5 41.4 29.8 69.7 73.9 100.1 114.9 9.4 12.7 20.1 25.8 35.1 30.5 40.5 12.7 70.1-44.3 60.4-85.6-9.7-41.3-38.9-77.7-40.3-120.1-2.4-74.7 78.1-122.2 148.7-146.8 70.7-24.6 153.9-54 174.7-125.8 7.3-25.4 5.4-53.3 16.6-77.3 37.1-79.3 232.8-118.9 186-164.9-46.8-45.9-195.3-55.9-224.2-148.6-10.3-33.1-21-76.9-55.6-80.1-56.3-5.3-88.5 64.5-135.7 76.4-22.5 5.7-24.6 43.8-23.7 90.7 0.6 34-26.5 62.1-60.5 62.7-34 0.7-62.1-26.4-62.7-60.4-0.3-12.6 1.9-25.4 7.1-38.1 9.1-22.3 26.4-40.1 43.8-56.8 72.7-69.4 289.6-145.6 244.2-175.2-45.4-29.5-263.4-111-295.9-66-32.5 45 21.2 6.9 34.4 60.2 13.1 53.4-161.3 46.2-241.9 69.3-13.3 3.8-28.1 7.6-40.5 1.5-14-6.7-19.8-22.9-27.4-36.4-40.5-72.4-175.1-25.4-175.1-25.4 0 0-41.9 24.1-68 66z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m1461.2 696.6c-19.6 36.5 38.6 35.9 44.4 76.9 52.4 5.8 74-76.9 125.8-86.5 29.2-5.4 57.6 15.5 73.5 40.7 15.9 25.1 23.3 54.6 36.7 81.2 30.2 59.4 92.6 101.2 159 106.6 14.4 1.2 30.4 0.3 41.2-9.3 31.6-27.8-13.6-80.1-1.8-120.6 13.4-46.2 80-39.1 125-56.1 12.5-4.7 108-30.1 109.5-43.3 2.7-23.4-41.6-38.3-91.2-51-83.9-21.6-231.7-20.7-303.9-14.2-96.1 8.7-256.2 1.7-318.2 75.6z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m3063.7 2266c21.8-136.3 20-276.4-5.3-412.1-6.8-36.2-22.6-79.3-59-84.5-42.2-6.1-93.8 42.4-120.2 8.9-11.6-14.7-7-36.2-0.4-53.8 17.4-46.4 44.7-89.1 79.4-124.5 21.6-21.9 46.3-41.4 63-67.3 35.5-55.5 10.6-136.5-39.8-179-50.3-42.5-115.3 33.7-168.2 3.4-52.9-30.2-54.6-103.6-64.5-163.7-7.4-44.6-40.2-165.3-76.5-106.5-36.2 58.8 48.4 292.8 143.6 404.9 11.5 13.6 24.2 28.7 23.2 46.4-2.3 42.4-63.9 40.5-105.4 49.1-51.4 10.8-130.1-16.7-86.7 72.7 23 47.2 132.4 111.8 103 143.4-29.4 31.6-119.8 123.1-162.2 197.1-42.5 74-63 166.1-31 245.2 32 79 128.1 133.6 206.7 100.3 36.7-15.6 76.7-48 110.9-27.3 30.9 18.7 26.4 63.5 24.8 99.7-1.5 36.1 19.3 84 54.5 75.5 11.5-2.8 20.6-11.5 28.4-20.5 49.5-56.8 69.8-133.1 81.7-207.4z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m2826.6 1752.1c0 544.4-467.2 985.7-1043.4 985.7-576.2 0-1043.4-441.3-1043.4-985.7 0-544.3 467.2-985.6 1043.4-985.6 576.2 0 1043.4 441.3 1043.4 985.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.7
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m2226 1862.2c-0.3 217.1-15.2 434.8-53.2 648.9-9.7 53.4-20.9 106.7-34.2 159.4-13.4 52.7-28.8 104.9-47.7 156-9.5 25.5-19.9 50.7-31.6 75.3-11.7 24.7-24.6 48.8-39.7 71.6-15.1 22.8-32.3 44.5-53.4 62.4-10.6 8.9-22.2 16.8-34.9 22.5-12.7 5.8-26.6 9.4-40.6 9.6-14.1 0.5-28.1-2.3-41.1-7.5-13-5.2-24.9-12.7-35.7-21.3-21.6-17.3-39.1-38.9-54.5-61.4-15.4-22.7-28.5-46.7-40.4-71.3-11.8-24.5-22.3-49.7-31.9-75.2-19.2-50.9-34.8-103.1-48.3-155.8-13.4-52.7-24.7-105.9-34.5-159.3-19.4-107-32.6-215-41.5-323.2-8.8-108.3-13.2-217-13.6-325.6-0.2-54.4 1.1-108.7 3-162.9q2.9-81.5 8.8-162.7c7.9-108.4 19.8-216.5 37.5-323.7 8.9-53.6 19.3-107 31.8-159.8 12.5-52.9 27-105.4 45.1-156.7 9.1-25.6 19-51 30.4-75.7 11.3-24.8 24-49 38.9-71.9 14.9-22.8 32-44.5 53.4-61.9 10.6-8.6 22.4-16.1 35.2-21.2 12.9-5.1 26.8-7.7 40.6-7.2 13.8 0.4 27.5 3.8 40.1 9.4 12.6 5.6 24.2 13.2 34.8 21.8 21.3 17.4 38.9 38.6 54.6 60.9 15.6 22.4 29.2 46 41.5 70.3 12.3 24.3 23.2 49.2 33.4 74.5 20.1 50.5 36.7 102.4 51.2 154.7 14.5 52.4 26.7 105.4 37.2 158.7 41.8 213.4 58.7 431.1 59.3 648.3zm-12.6 0c0.1-108.3-4-216.7-13.1-324.6-8.9-107.9-22.5-215.5-42.6-321.9-10.1-53.2-21.8-106.1-35.7-158.4-14-52.3-30.1-104-49.7-154.5-9.9-25.1-20.6-50-32.6-74.2-12-24.2-25.2-47.8-40.5-70.1-15.2-22.1-32.5-43.2-53.2-60.3-10.3-8.5-21.5-16-33.7-21.5-12.1-5.5-25.2-9-38.5-9.4-13.3-0.4-26.6 2.2-38.9 7.3-12.4 5-23.7 12.3-34 20.8-20.7 17.1-37.4 38.7-52 61.3-14.5 22.7-26.8 46.8-37.8 71.5-11.1 24.6-20.7 49.9-29.5 75.4-17.6 51.2-31.6 103.6-43.7 156.3-11.9 52.8-21.8 106.1-30.2 159.6-16.8 107-27.7 214.9-34.6 323-7 108.1-9.6 216.4-9.5 324.7-0.2 108.3 3.6 216.7 11.7 324.7 8.2 108 20.7 215.7 39.4 322.3 9.4 53.3 20.3 106.4 33.4 158.9 13.1 52.5 28.3 104.4 47 155.1 9.4 25.4 19.7 50.4 31.2 74.8 11.6 24.3 24.4 48.1 39.4 70.4 14.9 22.3 32 43.4 52.7 60.1 10.3 8.4 21.6 15.6 33.8 20.5 12.1 5 25.2 7.7 38.3 7.3 13.1-0.4 26-3.8 37.9-9.3 12-5.5 23-13 33.1-21.7 20.3-17.3 37-38.7 51.7-61.1 14.6-22.6 27.3-46.4 38.7-70.9 11.4-24.4 21.5-49.5 30.8-74.8 18.4-50.8 33.5-102.9 46.5-155.4 12.9-52.5 23.7-105.6 33-158.9 18.5-106.7 30.9-214.4 39.1-322.4 8.3-108 12.1-216.3 12.1-324.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m2773.8 1862.2c-0.2 69.8-4.7 139.7-14 209-9.3 69.3-23.2 137.9-41.9 205.3-37.9 134.5-95 264-172.8 380.2-38.9 58-83 112.7-132.3 162.2-49.3 49.6-103.9 94-163 131.3-59.2 37.2-123.1 67-190 87.3-67 20.1-136.9 30.5-206.8 30.5-69.9 0.1-139.8-10.3-206.8-30.4-67-20.2-130.9-50-190.1-87.2-59.2-37.2-113.8-81.6-163.2-131.1-49.3-49.6-93.5-104.2-132.5-162.3-77.9-116.2-135.1-245.7-173.1-380.3-18.8-67.3-32.9-136-42.2-205.3-9.3-69.4-13.7-139.3-13.9-209.2 0.3-70 4.7-139.9 14-209.2 9.4-69.3 23.5-138 42.3-205.4 38.1-134.5 95.4-263.9 173.3-380.1 39-58 83.2-112.5 132.6-162 49.3-49.5 103.9-93.9 163.1-131 59.2-37.1 123.1-66.7 190-87 66.9-20 136.7-30.5 206.5-30.4 69.9 0 139.7 10.5 206.5 30.6 66.9 20.2 130.8 49.9 189.9 87 59.2 37.2 113.7 81.6 162.9 131.1 49.3 49.5 93.4 104.1 132.4 162.1 77.8 116.1 135 245.5 172.9 380 18.8 67.3 32.7 136 42.1 205.2 9.4 69.3 13.8 139.2 14.1 209.1zm-14.4 0c-0.1-69.3-4.2-138.6-13.3-207.3-9-68.7-22.6-136.8-40.9-203.5-36.8-133.5-92.2-262.4-168.5-378.2-38.1-57.9-81.5-112.4-130-161.9-48.5-49.4-102.1-94.1-160.6-131.2-58.6-37.1-121.8-67-188.1-87.2-66.4-20.1-135.6-30.5-205-30.6-69.3 0.1-138.6 10.6-204.9 30.7-66.3 20.3-129.5 50.2-188 87.3-58.4 37.2-112 81.9-160.5 131.4-48.4 49.5-91.7 104-129.7 161.9-76.2 115.8-131.6 244.6-168.1 378-36.5 133.6-54.2 272.1-54.1 410.6 0 138.4 17.7 276.9 54.3 410.5 36.6 133.4 92.1 262.1 168.3 377.8 38 57.8 81.3 112.3 129.7 161.8 48.5 49.4 102 94 160.5 131.1 58.5 37 121.7 66.8 187.9 87.1 66.2 20.1 135.4 30.6 204.6 30.8 69.3-0.1 138.4-10.6 204.7-30.7 66.2-20.2 129.5-49.9 188-86.9 58.5-37.1 112.1-81.7 160.6-131.1 48.5-49.5 91.8-103.9 130-161.7 76.3-115.8 131.9-244.5 168.7-378 18.4-66.8 31.9-134.8 41-203.5 9.1-68.7 13.3-138 13.4-207.2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m776.2 1384.9l277.1-1.7 277.1-1 554.3-0.8 554.3 0.8 277.1 1.1 277.1 1.9c0.4 0 0.6 0.3 0.6 0.7 0 0.3-0.2 0.6-0.6 0.6l-277.1 1.9-277.1 1.1-554.3 0.9-554.3-0.8-277.1-1-277.1-1.8c-0.5 0-1-0.4-1-0.9 0-0.6 0.5-1 1-1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m1097.7 920.7l196.7-1.7 196.8-1c65.6-0.4 131.2-0.4 196.7-0.5l196.8-0.3 393.5 0.9 196.8 1.1 196.7 1.9c0.4 0 0.6 0.2 0.6 0.6 0 0.3-0.2 0.6-0.6 0.6l-196.7 1.9-196.8 1.1-393.5 0.9-196.8-0.3c-65.5-0.1-131.1-0.1-196.7-0.5l-196.8-1-196.7-1.8c-0.5 0-1-0.4-1-0.9 0.1-0.5 0.5-1 1-1z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m679.9 1849.1l301.2-1.8 301.2-1 602.4-0.8 602.4 0.9 301.2 1.1 301.2 1.9c0.4 0 0.6 0.3 0.6 0.6 0 0.4-0.2 0.7-0.6 0.7l-301.2 1.9-301.2 1-602.4 0.9-602.4-0.8-301.2-1-301.2-1.7c-0.5 0-1-0.5-1-1 0-0.5 0.5-0.9 1-0.9z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m776.2 2313.2l277.1-1.7 277.1-1 554.3-0.8 554.3 0.9 277.1 1.1 277.1 1.8c0.4 0.1 0.6 0.3 0.6 0.7 0 0.3-0.2 0.6-0.6 0.6l-277.1 1.9-277.1 1.1-554.3 0.9-554.3-0.8-277.1-1-277.1-1.8c-0.5 0-1-0.4-1-0.9 0-0.5 0.5-1 1-1z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m2711.4 2781.7h-1574.1c-1.8 0-3.3-1.5-3.3-3.3 0-1.9 1.5-3.4 3.3-3.4h1574.1c1.8 0 3.3 1.5 3.3 3.4 0 1.8-1.5 3.3-3.3 3.3z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m1886.2 1638.5c-188.6-33.9-369.8-110.3-510.9-217l12.1-7.2c168.6 127.6 395.6 210.8 622.8 228.6 227.3 17.7 453.6-30.4 621-131.9 73.4-44.5 130.8-95.8 170.7-152.4l15.8 6.3c-40.7 57.8-99.2 110.1-174 155.4-170.5 103.4-401.2 152.3-633 134.3-41.6-3.3-83.3-8.6-124.5-16.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m2802.7 1730.8c-34.1-57.3-52.7-111.7-55.2-162.6-6.6-128 92.4-188.5 93.4-189.1l5.9 9.9c-1 0.5-96.5 59.1-90.2 181.9 4.2 83.3 53.5 177 146.6 278.5l-5.1 6.7c-39.5-43.1-71.3-84.9-95.4-125.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m1325.4 1401.2c-7.1 2.4-13.7 2.3-19.1-0.3l5.6-7.1c10.8 5.3 27.6-10 30.9-13.1 72.3-69.1 124.2-145.8 149.9-221.9 28.5-84.1 25-167.9-9.7-236l8.9-3.9c35.5 69.6 39.1 155.2 10 241-26.2 77.5-78.8 155.4-152.3 225.6-8.2 7.8-16.5 13.2-24.2 15.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m2651.5 2283.8l-10.8-1c1.7-40.1 17.5-77.2 34.3-111.3 43.7-88.6 98.5-170.1 163-242.3 24.4-27.3 51.7-55 85.7-71.9l4.9 10.5c-32.5 16.2-58.9 43-82.7 69.5-63.8 71.5-118.1 152.2-161.3 239.9-16.3 33-31.5 68.7-33.1 106.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s10",
    d: "m1421.7 1375.7c0 44.7-36.3 81-81.1 81-44.7 0-81-36.3-81-81 0-44.8 36.3-81.1 81-81.1 44.8 0 81.1 36.3 81.1 81.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m2898.7 1392.8c0 44.8-36.3 81-81.1 81-44.7 0-81-36.2-81-81 0-44.7 36.3-81 81-81 44.8 0 81.1 36.3 81.1 81z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m1530.9 921c0 44.8-36.3 81-81.1 81-44.7 0-81-36.2-81-81 0-44.8 36.3-81 81-81 44.8 0 81.1 36.2 81.1 81z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s13",
    d: "m2744.3 2289.6c0 44.8-36.2 81.1-81 81.1-44.8 0-81-36.3-81-81.1 0-44.7 36.2-81 81-81 44.8 0 81 36.3 81 81z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m3009.1 1850c0 44.7-36.2 81-81 81-44.7 0-81-36.3-81-81 0-44.8 36.3-81.1 81-81.1 44.8 0 81 36.3 81 81.1z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s15",
    d: "m2232.6 1947.1c-31.5-21.7-89.3 38.7-89.3 38.7 0 0-151.7 8.3-198.1-8.4-46.3-16.7-39.2-199.2-39.2-199.2 0 0-147-73.2-131.3 162.6 13.6 204.5 364.1 85.2 364.1 85.2 0 0 88 13.4 111.5-2.3 23.4-15.7 13.8-54.9-17.7-76.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s16",
    d: "m2152.5 1977.9c0 0 15-39.2 48-44.9 32.9-5.8 31.9 0.4 26.3 8.8-5.5 8.4-63.4 55.8-74.3 36.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s17",
    d: "m1945.2 1977.4c-46.3-16.7-9.4-210-9.4-210 0 0-170.9-62.7-161.1 173.4 4.4 108.8 123.2 129.2 215.6 119.8 4.6-30.8 3.2-44.7 13.7-74.3-6.8-1.2-53.9-7.2-58.8-8.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s18",
    d: "m2046.8 1888.7l17.8 202.8c1.2 13.4 13 23.2 26.4 22l133.9-12.5c14.4-1.4 24.4-15.1 21.2-29.2l-46.2-208.6c-2.8-12.7-15.1-20.9-27.8-18.7l-105.4 18.4c-12.3 2.1-21 13.3-19.9 25.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m2170.7 1962.1c-9.6 16.2-30.4 21.5-46.6 12-16.1-9.6-21.5-30.4-11.9-46.6 9.5-16.1 30.4-21.5 46.5-11.9 16.2 9.5 21.5 30.4 12 46.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m2099.5 2076.3l-0.7-6.5c0-0.5 0.3-0.9 0.7-0.9l105.9-10.9c0.4 0 0.8 0.3 0.8 0.7l0.7 6.6c0 0.4-0.3 0.8-0.7 0.8l-105.8 10.9c-0.5 0.1-0.9-0.2-0.9-0.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m2097.5 2056.7l-0.7-6.5c0-0.5 0.3-0.9 0.7-0.9l105.8-10.9c0.5 0 0.9 0.3 0.9 0.7l0.7 6.6c0 0.4-0.3 0.8-0.7 0.8l-105.8 10.9c-0.5 0.1-0.9-0.2-0.9-0.7z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s20",
    d: "m2228 1948.3c0 0-36.9-6.4-38.9 17.1-2 23.5-8 56.4 11.9 60.1 19.9 3.6 56.5 11.4 62.8-18.7 6.3-30.2-31.1-69-35.8-58.5z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s21",
    d: "m1808.1 1591.8c-10.5 8.2-134.9 18.2-227.1 38-66.9 14.4-112 77.2-104.3 145.1l11 97.3c1.4 12.2 14.2 19.5 25.4 14.4l261.2-119.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s22",
    d: "m1791.4 2190.5h-264.4c-8.5 0-15.3-6.8-15.3-15.3v-515c0-12.5 10.1-22.6 22.6-22.6h257.1z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s23",
    d: "m1644.8 2566l-29.6 48.5c0 0-236.3 222.7-325.5 316.4-14 14.7-23.2 33.2-26.5 53.2l-17.4 104.4-51.6-155.4 11.4-10.1 36-13.4 215-292.8c12.6-17.2 30-30.4 49.9-38l58-22.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s24",
    d: "m1269 2851.3c4.9 33.7 27.7 49.4 55.3 60.3l302.3-303.9 158.6-377.1 36.3-223.5-65.2-16.3c-147.9 28.6-167.3 314.9-198.7 568.5-94.7-1.7-188.8 149-288.6 292z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s25",
    d: "m1237.5 2907.2c0 0-73.2 11.8-55.4 66.5 17.9 54.8 45.3 156 81 135.7 35.7-20.2-5.2-132.4 12.8-160.2-34.1-26.7-38.4-42-38.4-42z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s26",
    d: "m1831.3 2544.9l9.6 56.1c0 0-31.9 323-37.6 452.3-0.9 20.2 4.3 40.3 15 57.5l55.4 90.1-140.9-83.2-2.8-17.2 23-31.7-30.2-361.9c-1.7-21.3 2.6-42.6 12.7-61.5l29.1-54.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s27",
    d: "m1923.7 2007.1c32.6 60.6-3.1 232.5-81.2 584.6l-36 406.2c-22.9 18.8-46.8 25.3-71.7 19-23.4-202.6-31.8-348.8 23-432.7l13-336.9 49.7-231.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s28",
    d: "m1742.8 3082.8c0 0-62.1 64.1-14.9 78.6 47.2 14.5 169.4 63.1 176.9 39.5 9.3-29.5-98.4-118.1-98.4-118.1-18.5 9.6-51 11.1-63.6 0z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s29",
    d: "m1756.3 1990.8c48.2-204.3-53.5-356.9-53.5-356.9 58-55.7 148.1-59.3 189.1-57.8 14.1 0.6 27.6 5.8 38.6 14.7 32.6 26.4 99.5 88.8 87.4 147.2-9.3 44.9-94.2 269.1-94.2 269.1 0 0-78.4 37.1-167.4-16.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s30",
    d: "m1847.4 1428.4l-39.3 163.4c-3.7 15.5 10.4 20.3 26.1 22.6 37.1 5.5 65.2-8.6 69.9-34.7 0.4-2.3 1.6-4.4 2-6.7l16.8-122c1.3-9.7-3.9-19.1-12.8-23.1l-32.5-14.4c-12.5-5.5-27 1.6-30.2 14.9z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s31",
    d: "m1884 1295.8c0 0 55.1 15 100.8 85.7 45.7 70.6 23.9 109-8.7 118.3-32.7 9.3-82.6 15.3-141.9-26.3-59.2-41.7-21.6-194.7 49.8-177.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s32",
    d: "m1864.2 1428.4c0 0-54.3-105.1 43.4-119.6l25.2 13c0 0-8.8-50.8-71.7-72.1-62.9-21.2-110.8 1.4-125.2 84.2-14.4 82.8 7.2 132.1 54.1 164.4 46.9 32.4 58.2-13 58.2-13 0 0-27.5-32.5-20.8-52.7 6.7-20.3 31.1-0.2 31.1-0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s33",
    d: "m1748.9 1417.4c0 0-189.8-58.4-221 139.5-31.2 197.9-52.8 261.4-99.8 227.2 0 0 7.7 74 98 40.9 234.5-85.7 91.8-360.4 222.8-407.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s34",
    d: "m1518.8 2078.2c-54.8-233.6 184-444.3 184-444.3 56.9 13.1 71.5 50.6 56.2 105.4-112.4 105.3-154.5 224.7-163.1 325.1-15.3-4.4-51.9-11.4-77.1 13.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s35",
    d: "m1595.9 2064.4c-10.7 44.1-9.6 77-8 92.7 0.6 5.6 3.4 10.2 9.4 10.5 2.7 0.1 5.5-0.3 8.2 0.4 2.7 0.7 5.2 3.1 4.8 5.9-0.2 1.3-1 2.4-1.3 3.7-0.6 2.5 0.9 5.1 3 6.6 2.1 1.5 4.6 2.2 7.1 3.1 9.6 3.5 19.8 9.7 28.8 14.4 2.7 1.4 3.2 5 2.7 8-3.9 26.3-40.8 23.8-58.4 14.7-10.8-5.6-20.6-14.5-27.2-24.7-27.1-41.9-41.1-82.8-46.2-121.5 25.2-25.2 61.8-18.2 77.1-13.8z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s36",
    d: "m1726.1 1612.4c88.4 135.5-17.1 400.8-44.7 411.3 121.2-24.4 166.3-245.6 98.8-433.9-19.8-1.5-40.1 5.2-54.1 22.6z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s37",
    d: "m1292 2291.4c10.2-20.6 1.6-45.3-16-63.7-12.2-12.7-18.6-30-17.7-47.6 3.7-81-34.1-329.6-72.1-359.9-66.1-52.9 17.6 389.8 36.3 402.7 20.8 5.7 4.4 93.9-5.7 108.2-16.7 23.9 51 8.8 75.2-39.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s38",
    d: "m1183.9 2109.2c20.8-24.3 42.8-42.2 67.5-46.1 4.5-0.7 7.6-4.8 7.3-9.2l-26.6-350.7-118.4 96.2z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s39",
    d: "m1316.7 2216.5l-177.6 85.9c-11.7 5.7-16.5 19.8-10.8 31.5l57.4 116.9c6.2 12.6 22 16.9 33.8 9.2l173-113.7c10.5-6.9 13.7-20.8 7.3-31.6l-52.9-89.1c-6.2-10.5-19.3-14.4-30.2-9.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m1292.8 2353.9c-17.9-3.1-29.9-20.1-26.8-38 3.1-17.9 20.1-29.9 38-26.9 17.9 3.1 29.9 20.1 26.8 38.1-3 17.9-20.1 29.9-38 26.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m1164.9 2328.8l5.6-2.9c0.4-0.2 0.9 0 1.1 0.4l46.3 92c0.2 0.4 0 0.9-0.4 1.1l-5.6 2.8c-0.4 0.2-0.9 0.1-1.1-0.3l-46.3-92.1c-0.2-0.4 0-0.8 0.4-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m1182 2320.2l5.6-2.9c0.4-0.1 0.9 0 1.1 0.4l46.2 92.1c0.2 0.3 0.1 0.8-0.3 1l-5.7 2.9c-0.3 0.2-0.8 0-1-0.4l-46.3-92c-0.2-0.4 0-0.9 0.4-1.1z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s40",
    d: "m1230.1 2214.3c0 0-31.7 29.7-24.3 63.5 7.4 33.8 12.9 30.4 18.8 21.8 5.8-8.6 28.7-82.5 5.5-85.3z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s41",
    d: "m991.2 2228.2h-233.3c-28 0-50.8-22.8-50.8-50.8-48.3-169.3-26-365.6 30.8-582.3 7.4-28.1 32.9-47.7 62-47.7h191.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s42",
    d: "m803.4 1532.5c-37.5 0-70.3 25.3-79.9 61.5l-37.9 144.2c-8.3 31.5 16.3 62.5 55.4 69.8l71.9 13.5 230.6-321.3z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s43",
    d: "m1167.9 2150l-221.1-8c0 0-50.3 72.6-51.5 89.9-0.6 9.2-1.1 17.9-1.4 26.3l-40.3 365.8c-1.3 11.9-5.2 23.3-11.4 33.5l-151.3 258.8c-5.4 8.4-18.1 23.1-11.9 30.9 7.2 9.1 6 25.3 22.7 32.2 6.2 2.6 35.4-26.8 39.9-31.8l225.8-257.8c7.4-8.5 12.7-18.6 15.4-29.5l64.6-240.5c41 120.4 89.6 518.8 98.3 598.9 0.9 8.3 4.9 97.2 13.3 97.9 15.7 1.4 30.2-3.5 43.3-5.4 8.9-1.3 5.9-68.7 6.5-77.6 31.8-492.4-40.9-883.6-40.9-883.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s44",
    d: "m678.5 2936.7c0 0-73.3 11.7-55.4 66.5 17.8 54.7 45.2 155.9 80.9 135.7 35.7-20.2-19.3-138.7 9.1-165-34.1-26.7-34.6-37.2-34.6-37.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s45",
    d: "m1156.4 3110.3c0 0-47.6 69.1 0 82.2 47.6 13.1 142.8 47.2 169 21.2 26.2-26-121-107.9-121-107.9-18.2 10.1-35.1 15.2-48 4.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s46",
    d: "m1270 1728.4c23.2-85.1-32.6-171.2-119.6-185.8-96.9-16.2-195.8-0.4-244.4 2.7-24.6 1.6-47.7 12.3-65 30-68.4 70.1-221 264.2-68.2 478.3 21.8-10.4 53-27.4 74.7-48-15.2-52.6-12.7-118.5 30.5-196.9q1.4 9.8 3.8 19.3c42.6 170.3 37 309.6 34.9 341.7-0.3 4.3 1.9 8.4 5.8 10.2 67.7 32.2 179.8 25.5 225.2 21.5 8.3-0.7 25.9-1.9 28.4-9.9 33.2-106.4 57-327.8 93.9-463.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s47",
    d: "m880.5 1792c-19.1-68.2-9.6-145.3-6.9-163.4 0.3-2.2 2.3-3.6 4.5-3.2 2.1 0.3 3.5 2.3 3.2 4.3-2.6 17.5-12.1 93.4 6.7 160.2 0.6 2.1-0.6 4.2-2.6 4.8-2.1 0.6-4.3-0.6-4.9-2.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s48",
    d: "m847.5 2005.6c-21.7 20.6-52.9 37.6-74.7 48 29.1 40.9 69.5 82.6 123.7 124.3l6.5 17.4c4.9 12.9 13.7 24 25.2 31.6l21.9 14.5c11.9 7.9 27.7 6.8 38.4-2.7l9.5-8.4c8.6-7.7 9.8-20.8 2.7-30l-27-34.4c-4.7-6.1-38.3-11.3-44.7-15.6-23.6-16.1-58.7-65.2-81.5-144.7z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s49",
    d: "m1040.8 1383l-27 163.6c-0.7 4.4 1.9 8.7 6.2 9.9 20.5 5.9 74.1 21.6 121.4-7.6l-14.2-133.5z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s50",
    d: "m1126 1258.5c1.9 1.8 81.1 157.3 81.1 157.3l-89.8 43.4-96.9-136.3c0 0 73.4-94.7 105.6-64.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s51",
    d: "m1060.1 1326.7c-1.6 4.1-1.2 8.8 1.1 12.6l44.7 74.6q1.1 1.7 2.5 3.1c5.3 4.9 23.6 19.3 37.7-0.3 12-16.7 23.3-32 35.3-38.2 7.1-3.7 15.8-0.8 19.3 6.3 7.4 14.6 21.7 44.4 30.7 72.7 2.2 7.1-1.4 14.7-8.3 17.5-18.2 7.3-54.1 20.7-86 25.1-5.2 0.7-10.4-1.5-13.5-5.8-13.7-18.8-52.4-71.3-65.6-84.4-16.1-16.1-38.5-1.7-57.2-6.7-0.9-0.2-1.8-0.5-2.5-1.2-0.6-0.8-0.8-1.9-0.9-2.9-0.5-5.8-0.2-11.7 1.1-17.5 0.4-1.8 0.9-3.7 1-5.6 0.1-4-1.7-7.6-3.3-11.2-7-16.1-10.2-33.8-16-50.4-0.8-2.3-1.6-4.6-1.4-7 0.1-1.6 0.7-3.2 1.3-4.7 4.7-11.6 13.6-21.4 24.5-27.7 9.3-5.4 27.8-5 32.4-16.1 1.5-3.7 6-5.7 8.7-8.5 4.3-4.4 8-9.7 11.9-14.6 4.5-5.6 9.7-11.6 16.9-12.8 4.3-0.8 8.8 0.4 13 1.6 7.3 1.9 14.8 4 20.9 8.4 7.8 5.8 12.5 14.8 16.7 23.6 2 4.4 3.9 9 3.2 13.7-1.9 12.5-22.2 19.2-32.8 20.6-20 2.5-31 24.4-35.4 35.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s52",
    d: "m1077.5 1433c0 0-19.9-46.1-41.9-44.3-22.1 1.9-39.4 23.8-12.1 48.5 34 30.7 54-4.2 54-4.2z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s53",
    d: "m868.7 1555.2c88.4 135.6 19.4 398-8.2 408.5 121.2-24.4 129.8-242.8 62.2-431-19.8-1.5-40.1 5.1-54 22.5z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s54",
    d: "m1022.4 1236.1c-5.7 4.6-13.4 4.4-17.2-0.4-3.8-4.8-2.3-12.3 3.4-16.9 5.8-4.5 13.5-4.3 17.3 0.5 3.8 4.7 2.2 12.3-3.5 16.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s55",
    d: "m991.9 1377.3c-89.8-138.3 111.6-239.6 168.8-100.5-55.9 25.6-112.3 60-159.6 101.7-2.8 2.5-7.1 1.9-9.2-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s56",
    d: "m1042.1 1345.3c66.5-18.4 148.1-28.5 175.5-47.9 24.1-14.3 30.3-42.3 10.8-37.2l-72.2 17.7c-43.1 12.6-80.5 36.3-114.1 67.4z"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s57",
    d: "m2501.1 812.1l-93.4-54.6c-1.9-1.1-4.2-1.5-6.3-1l-119 27.6c-3.2 0.8-5.7 3.2-6.5 6.4-0.8 3.2 0.3 6.6 2.8 8.7l73.3 62.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s58",
    d: "m1707.3 938.5c0 0 1109.6-228.2 1153.4-215.4 43.9 12.8 122.8 56.9 145.7 56.4 23-0.5 103.5 11.6 84.1 69.3-19.4 57.8-939.2 256.6-1047.8 222.3-108.5-34.3-382.7-97.1-382.7-97.1 0 0-26.1-38.5 47.3-35.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s59",
    d: "m2028.6 876.6l-162.6-85.1c-10.2-5.4-18.7-13.5-24.5-23.4l-67.8-115.5c-5.4-9.2-16.1-13.8-26.5-11.3-33 7.9-101.6 25.1-101.7 32.9-0.2 10.4 40 268.4 40 268.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s60",
    d: "m1718.7 975.4l-12 54.9c-2 9.2 0.3 18.6 6.4 25.9 6 7.3 15.1 11.1 24.5 10.9l56.7-1.2c8.9-0.2 17.4-3.9 23.1-10.8l98.3-117.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s61",
    d: "m2307.1 1143.1c0 0 35.3 41.4 91.2 40.2 55.9-1.2 124.3-18.2 136.7-38.2 12.5-20.1 36.8-166.7-76.2-143.2-113 23.4-243.9 92.5-151.7 141.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s62",
    d: "m2240.2 993.7l263.7-52.6-215.8 290.8c-3 4-7.6 6.7-12.6 7.2l-158.3 16.9c-6.9 0.7-13.6-2.5-17.3-8.3-3.7-5.8-3.8-13.2-0.3-19.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s63",
    d: "m2513.2 1144.6c-15.4-16.1-43.4-79.3-37.9-107.1 3.6-17.8 16-21 25.7-20.5 12 0.5 22.6 7 28.5 17.4 20 35 14 81.8 3.4 103.9-3.3 6.8-6.8 10.6-10.3 11.1q-1 0.2-2 0c-2.2-0.4-4.7-2-7.4-4.8zm-12.4-122.8c-11.6-0.5-18.4 4.9-20.8 16.6-4.9 24.6 20.7 86.1 36.7 102.8 3.5 3.6 5 3.5 5.1 3.5 1.3-0.2 3.9-2.6 6.7-8.5 9.9-20.5 15.7-66.3-3.2-99.4-4.3-7.6-11.9-12.9-20.5-14.5q-1.9-0.4-4-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s64",
    d: "m1653.3 735.5l27.5-0.6 29.6 175-28.8 7.4z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s65",
    d: "m2110 936.8c-0.2-9 7-16.5 16-16.7h1.1c9-0.2 16.5 7 16.7 16l0.2 10.7c0.2 9.1-6.9 16.6-16 16.8h-1c-9.1 0.2-16.6-7-16.8-16.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s66",
    d: "m2172.7 930.7c-0.2-9.1 7-16.6 16-16.8h1c9.1-0.2 16.6 7 16.8 16l0.2 10.7c0.2 9.1-7 16.6-16 16.8h-1.1c-9 0.2-16.5-7-16.7-16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s67",
    d: "m2235.1 914.8c-0.1-9.1 7-16.5 16.1-16.7l1-0.1c9.1-0.2 16.6 7 16.8 16.1l0.2 10.7c0.2 9-7 16.5-16 16.7h-1.1c-9 0.2-16.5-7-16.7-16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s68",
    d: "m2292.9 903.9c-0.2-9.1 7-16.6 16-16.8h1.1c9-0.2 16.5 7 16.7 16l0.2 10.7c0.2 9.1-6.9 16.6-16 16.8h-1c-9.1 0.2-16.6-7-16.8-16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s69",
    d: "m2360.3 892.7c-0.2-9 7-16.5 16-16.7h1.1c9-0.2 16.5 7 16.7 16l0.2 10.7c0.2 9.1-6.9 16.6-16 16.7l-1 0.1c-9.1 0.2-16.6-7-16.8-16.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s70",
    d: "m2422.9 881.7c-0.2-9 7-16.5 16-16.7h1c9.1-0.2 16.6 6.9 16.8 16l0.2 10.7c0.2 9-7 16.5-16 16.7h-1c-9.1 0.2-16.6-6.9-16.8-16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s71",
    d: "m2485.4 865.9c-0.2-9.1 6.9-16.6 16-16.8h1c9.1-0.2 16.6 7 16.8 16l0.2 10.7c0.2 9.1-7 16.6-16 16.8h-1.1c-9 0.2-16.5-7-16.7-16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s72",
    d: "m2543.2 859.8c-0.2-9.1 7-16.6 16-16.8h1.1c9-0.2 16.5 7 16.7 16l0.2 10.7c0.2 9.1-6.9 16.6-16 16.8h-1c-9.1 0.2-16.6-7-16.8-16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s73",
    d: "m2605.8 848.7c-0.2-9 7-16.5 16-16.7h1.1c9-0.2 16.5 7 16.7 16l0.2 10.7c0.2 9.1-7 16.6-16 16.7l-1 0.1c-9.1 0.2-16.6-7-16.8-16.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s74",
    d: "m2668.3 832.9c-0.2-9.1 6.9-16.6 16-16.8h1c9.1-0.2 16.6 7 16.8 16.1l0.2 10.7c0.2 9-7 16.5-16 16.7h-1.1c-9 0.2-16.5-7-16.7-16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s75",
    d: "m2726.1 826.8c-0.2-9.1 7-16.5 16-16.7l1.1-0.1c9-0.2 16.5 7 16.7 16.1l0.2 10.7c0.2 9-6.9 16.5-16 16.7h-1c-9.1 0.2-16.6-7-16.8-16z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s76",
    d: "m2939.3 755.8l-109.5 33c-8.2 2.5-13.5 10.5-12.6 19.1 1.1 10.1 2.9 21.6 5.2 20.5 4-1.8 175.7-49.4 175.7-49.4z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginAdmin);
export default __webpack_public_path__ + "static/media/login_admin.5156e230bdcd64330e0afc2f0259f13d.svg";
export { ForwardRef as ReactComponent };